import React from "react";
import { ToastContainer } from "react-toastify";
import AddTag from "../../components/ProductManager/Tag/AddTag";

export const AddTagPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <AddTag />
        </div>
      </div>
    </div>
  );
};
